<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ titulo }} - Rut: {{ dataForm.rut }}</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="2" sm="2" md="2" class="pb-0">
            <v-text-field v-model="dataForm.rut" label="Rut" outlined required :disabled="!activate"
              :rules="[validationRut.required, validationRut.rut]"></v-text-field>
          </v-col>
          <v-col cols="5" sm="5" md="5" class="pb-0">
            <v-text-field v-model="dataForm.firstName" label="Nombres" outlined required
              :disabled="!activate"></v-text-field>
          </v-col>
          <v-col cols="3" sm="3" md="3" class="pb-0">
            <v-text-field v-model="dataForm.fatherName" label="Primer Apellido" outlined required
              :disabled="!activate"></v-text-field>
          </v-col>

          <v-col cols="2" sm="2" md="2" class="pb-0">
            <v-text-field v-model="dataForm.motherName" label="Segundo Apellido" outlined required
              :disabled="!activate"></v-text-field>
          </v-col>
          <v-col cols="5" sm="5" md="5" class="pb-0">
            <v-text-field v-model="dataForm.position" label="Cargo - Rol" outlined required
              :disabled="!activate"></v-text-field>
          </v-col>
          <v-col cols="4" sm="4" md="4" class="pb-0">
            <v-autocomplete v-model="dataForm.costCenter" :items="costCenters" label="Centro de Costo" outlined
              auto-select-first required :disabled="!activate"></v-autocomplete>
          </v-col>
          <v-col cols="3" sm="3" md="3" class="pb-0">
            <v-select :items="adminCostCenter" v-model="dataForm.adminCostCenter" label="Sup Centro Costo"
              :disabled="disabledForm" outlined></v-select>
          </v-col>

          <v-col cols="3" sm="3" md="3" class="pb-0">
            <v-text-field v-model="dataForm.email" label="Email" outlined required :disabled="!activate"
              :rules="[validationEmail.required, validationEmail.email]"></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" md="2" class="pb-0">
            <v-select :items="gender" v-model="dataForm.gender" label="Genero" outlined required
              :disabled="!activate"></v-select>
          </v-col>
          <v-col cols="3" sm="3" md="3" class="pb-0">
            <v-text-field v-model="dataForm.managerRut" label="Rut Jefe" outlined required
              :disabled="!activate"></v-text-field>
          </v-col>
          <v-col cols="4" sm="4" md="4" class="pb-0">
            <v-text-field v-model="dataForm.managerName" label="Nombre Jefe" outlined required
              :disabled="!activate"></v-text-field>
          </v-col>

          <v-col cols="4" sm="4" md="4" class="pb-0">
            <v-select :items="workgroups" v-model="dataForm.workgroupId" label="WorkGroup" :disabled="disabledForm"
              outlined></v-select>
          </v-col>
          <v-col cols="2" sm="2" md="2" class="pb-0">
            <v-select :items="adminCostCenter" v-model="dataForm.adminWorkGroup" label="Sup WorkGroup"
              :disabled="disabledForm || !dataForm.workgroupId" outlined></v-select>
          </v-col>
          <v-col cols="2" sm="2" md="2" class="pb-0">
            <v-text-field v-model="dataForm.calzado" label="Calzado" outlined required :disabled="!activate"
              type="number"></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" md="2" class="pb-0">
            <v-text-field v-model="dataForm.pantalon" label="Pantalon" outlined required
              :disabled="!activate"></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" md="2" class="pb-0">
            <v-text-field v-model="dataForm.uniforme" label="Uniforme" outlined required
              :disabled="!activate"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">
        Volver
      </v-btn>
      <v-btn v-if="!disabledForm && activeSave" color="blue darken-1" text @click="save">
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import UserProfile from "../../data";
import ImageInput from '../../components/ImageInput.vue';
import { formatRut, validateRut, cleanRut } from 'rutlib';
import validateEmail from '../../tools/validateEmail';
export default {
  components: {
    ImageInput
  },
  props: {
    titulo: {
      type: String,
      default: "Nuevo Empleado",
    },
    dataForm: {
      type: Object,
      default: {},
    },
    workgroups: {
      type: Array, default: () => []
    },
    costCenters: {
      type: Array, default: () => []
    },
    disabledForm: {
      type: Boolean,
      default: false,
    },
    newEmployee: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    user: UserProfile.getUserData(),
    search: "",
    dialog: false,
    dialogDelete: false,
    avatar: null,
    avatarTmp: null,
    chosenFile: null,
    headers: [
      {
        text: "Título",
        align: "start",
        sortable: false,
        value: "titulo",
      },
      { text: "Tipo de ticket", value: "tipo" },
      { text: "Lugar", value: "lugar" },
      { text: "Planificación", value: "tipoPlanificacion" },
      { text: "Tipo de Creador", value: "tipoCreador" },
      { text: "Servicio", value: "tipoServicio" },
      { text: "Asignación", value: "asignado_a" },
      { text: "Creado por", value: "creado_por" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    adminCostCenter: [
      { text: "Si", value: true },
      { text: "No", value: false },
    ],
    gender: [
      { text: "Masculino", value: "M" },
      { text: "Femenino", value: "F" },
    ],

  }),
  computed: {
    validationRut() {
      return {
        required: value => !!value || 'Requerido.',
        rut: value => validateRut(value) || 'RUT inválido'
      }
    },
    validationEmail() {
      return {
        required: value => !!value || 'Requerido.',
        email: value => validateEmail(value) || 'Email inválido'
      }
    },
    activeSave() {
      return (
        this.dataForm.rut &&
        this.dataForm.firstName &&
        this.dataForm.fatherName &&
        this.dataForm.motherName &&
        this.dataForm.position &&
        this.dataForm.costCenter &&
        //this.dataForm.adminCostCenter !== null &&
        this.dataForm.email &&
        this.dataForm.gender &&
        this.dataForm.managerRut &&
        this.dataForm.managerName &&
        this.dataForm.calzado &&
        this.dataForm.pantalon &&
        this.dataForm.uniforme
      );
    },
    activate() {
      return (
        this.newEmployee || !this.dataForm.talana
      )
    }
  },
  mounted() {
    if (this.dataForm?.photo != "") {
      this.avatarTmp = this.dataForm.photo;
    }
  },

  methods: {
    close() {
      this.$emit("recibeTickect", undefined)
      this.avatar = null;
      //this.avatarTmp = null;
      this.chosenFile = null;
    },

    save() {
      console.log("!!!!", this.dataForm)
      this.$emit("recibeTickect", this.dataForm)
    },
  },
  watch: {
    avatar() {
      if (this.avatar) {
        this.avatarTmp = this.avatar.imageURL
        this.chosenFile = this.avatar.imageFile
      }
    },
    'dataForm.rut': function (newVal, oldVal) {
      this.dataForm.rut = formatRut(newVal);
    },
  }
};
</script>

<style lang="scss">
.combo-parametros {
  .v-select__selections {
    min-height: 56px !important;
  }
}

.theme--dark.v-chip.default {
  background: #f1f1f1;
  color: rgba(0, 0, 0, 0.87);
}

.v-text-field__details {
  display: none;
}
</style>
